export default {
    name: "RefreshCurrent",
    title: "RefreshCurrent",
    icon: "mdi-file-refresh-outline",
    create() {
        return {
            name: this.title,
            description: null,
            actionType: this.name,
            component: null,
        };
    },
};